(function ($) {
  const googlePlaceAPIKey = "AIzaSyD1KKZahq_3wo4cKy0sdbxrQ3ZuZgKvmJU";
  const googleGeoCodeAPIKey = "AIzaSyB_VonSxBVWESqib15Kn9Qi99j5P0ukiyo";

  // Load the Google Maps API script
  const script = document.createElement("script");
  script.src = `https://maps.googleapis.com/maps/api/js?key=${googlePlaceAPIKey}&libraries=places&callback=initializeAutocomplete`;
  $("head").append(script);

  window.initializeAutocomplete = function () {
    const input = document.querySelector("#autocomplete");

    if (input) {
      const options = {
        types: ["geocode"], // Restrict the results to geographical locations
        componentRestrictions: { country: "US" }, // Limit results to the United States
      };
      const autocomplete = new google.maps.places.Autocomplete(input, options);

      // Listen for the 'place_changed' event when a place is selected
      autocomplete.addListener("place_changed", function () {
        document.querySelector("#sameday-error").classList.add("hidden");

        const place = autocomplete.getPlace();
        const postalCode = place?.address_components.find(
          (component) => component.types[0] === "postal_code"
        );

        const hasStreetNumber = place?.address_components.find(
          (component) => component.types[0] === "street_number"
        );

        // Display error and reset location if no postal code or street number
        if (!postalCode || !hasStreetNumber) {
          document.querySelector("#sameday-error").classList.remove("hidden");
          $("#selection-local-delivery .location-search-results ul").html("");
          return;
        }

        handleSearchSubmit(
          null,
          "#selection-local-delivery",
          "deliverySelection",
          postalCode?.long_name
        );
      });
    }
  };

  // Submit a search for store locations
  async function handleSearchSubmit(
    event,
    parentSelector,
    localStorageKey,
    googlePostalCode
  ) {
    let postalCode;
    if (event) {
      event.preventDefault();

      // prevent dupe network calls on paste ( cmd or ctrl key pressed )
      if (event.keyCode == 91 || event.keyCode == 17) {
        return;
      }

      postalCode = event.target
        .closest(".selection-form")
        .querySelector("input").value;
    }

    if (googlePostalCode) {
      postalCode = googlePostalCode;
      $(`${parentSelector} .location-search-results ul`).html("");
    }

    const locationSyncData = document.querySelector("[data-location-sync]")
      ?.innerHTML
      ? JSON.parse(document.querySelector("[data-location-sync]").innerHTML)
      : null;

    const GADGET_URL =
      locationSyncData?.location_sync_gadget_app_url ||
      "https://ps-inventory-sync.gadget.app";

    // google geo location fetch
    if (postalCode.length >= 5) {
      fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${postalCode}&key=${googleGeoCodeAPIKey}`
      )
        .then((res) => res.json())
        .then((geoLocation) => {
          if (geoLocation.results.length) {
            const coordinates = geoLocation.results[0].geometry.location;
            $(`${parentSelector} .location-search-results ul`).html("");
            $(`${parentSelector} .location-search-results .loading`).show();

            fetch(
              `${GADGET_URL}/locations/closest?latitude=${coordinates.lat}&longitude=${coordinates.lng}`
            )
              .then((res) => res.json())
              .then(async (response) => {
                let locations = response;

                /**
                 * If deliverySelection is the current localStorageKey, we need to validate the location with Zapiet
                 * Filters shopify locations with zapiets locations and adds the zapietId to the shopify location
                 */
                if (localStorageKey === "deliverySelection") {
                  try {
                    const deliveryLocation = await validateZapietLocations(
                      postalCode
                    );
                    const filteredLocation = locations.find((location) =>
                      location.name.includes(deliveryLocation.company_name)
                    );
                    filteredLocation.zapietId = deliveryLocation.id;
                    locations = [];
                    locations.push(filteredLocation);
                  } catch (error) {
                    $(
                      `${parentSelector} .location-search-results .loading`
                    ).hide();
                    return;
                  }
                }

                const locationSelection = localStorage.getItem(localStorageKey);
                let result_html = "";

                locations.forEach((location, index) => {
                  /** Format the name */
                  location.name = location.name.replace(
                    "Physical Location - ",
                    ""
                  );
                  const display_item = $.extend({}, location);
                  let item_template;

                  if (
                    locationSelection &&
                    JSON.parse(locationSelection).externalStoreID ==
                      location.name.split(" ")[0]
                  ) {
                    display_item.isCurrentLocation = true;
                  }

                  if (index <= 4) {
                    item_template = _.template(resultTemplate, display_item);
                    result_html += item_template({ data: display_item });
                  }
                });

                $(`${parentSelector} .location-search-results ul`).html(
                  result_html
                );
                $(`${parentSelector} .location-search-results .loading`).hide();
              });
          } else {
            $(`${parentSelector} .location-search-results ul`).html("");
          }
        });
    } else if (postalCode.length === 0) {
      $(`${parentSelector} .location-search-results ul`).html("");
    }
  }

  /* ----------------------------------------------------------------
    Store Location Lookup and Saving
    -----------------------------------------------------------------*/
  // IIFE to contain variable scope
  const getZapietLocations = async (zipcode) => {
    return fetch(
      `https://api-us.zapiet.com/v1.0/delivery/locations?shop=${Shopify.shop}&geoSearchQuery=${zipcode}`
    ).then((res) => res.json());
  };

  const validateZapietLocations = async (zipcode) => {
    return new Promise((resolve, reject) => {
      if (
        typeof window.Zapiet === "undefined" ||
        typeof window.Zapiet.DeliveryValidator === "undefined" ||
        window.ZapietCachedSettings.cached_config === "undefined" ||
        window.ZapietCachedSettings.cached_config.delivery_validator ===
          "undefined"
      ) {
        console.warn(
          "Zapiet - Custom delivery validator error. Please ensure you have Store Pickup + Delivery correctly installed. Contact support@zapiet.com for assistance."
        );
        reject(new Error("Zapiet not properly configured"));
        return;
      }

      Zapiet.DeliveryValidator.checkEligiblity(
        zipcode,
        async function (response) {
          const zapietLocations = await getZapietLocations(zipcode);
          if (zapietLocations?.distance <= 20) {
            resolve(zapietLocations);
          } else {
            document.querySelector("#sameday-error").classList.remove("hidden");
          }
        },
        function (response) {
          // Show error message
          document.querySelector("#sameday-error").classList.remove("hidden");
          reject(new Error(response));
        },
        function (response) {
          // Show error message
          document.querySelector("#sameday-error").classList.remove("hidden");
          reject(new Error(response));
        }
      );
    });
  };

  /* Resets our selection UI
   * - used when closing modal, or deselecting
   */
  function resetForm() {
    $(".location-search-results ul").html("");
    $(".selection-form__form input").val("");
  }

  // store our markup templates
  const resultTemplate = $("#store_lookup_results_markup").html();
  const currentLocationTemplate = $("#current_location_markup").html();
  const locationSelection = localStorage.getItem("locationSelection");
  const deliverySelection = localStorage.getItem("deliverySelection");

  const showSelectedLocation = (locationData, selector) => {
    if (!locationData || !Object.values(locationData).length) {
      $(`${selector} .change-location`).addClass("change-location--hidden");
      return;
    }

    let locationTemplate = "";
    // Remove the locationSelection if name doesnt exist (old data structure of it was causing issues unless localStorage is cleared)
    if (!JSON.parse(locationSelection)?.address1) {
      localStorage.removeItem("locationSelection");
    }

    if (!JSON.parse(deliverySelection)?.address1) {
      localStorage.removeItem("deliverySelection");
    }

    locationTemplate = _.template(
      currentLocationTemplate,
      JSON.parse(locationData)
    );

    $(`${selector} .current-location`).html(
      locationTemplate({ data: JSON.parse(locationData) })
    );
  };

  window.initLocationUI = function () {
    showSelectedLocation(locationSelection, "#selection-bopis");
    showSelectedLocation(deliverySelection, "#selection-local-delivery");
  };

  initLocationUI();

  // BOPIS locations search submit handler
  $(document).on(
    "click",
    "#selection-bopis .selection-form button",
    (event) => {
      handleSearchSubmit(event, "#selection-bopis", "locationSelection");
    }
  );

  // Local Delivery locations search submit handler
  $(document).on(
    "click",
    "#selection-local-delivery .selection-form button",
    (event) => {
      handleSearchSubmit(
        event,
        "#selection-local-delivery",
        "deliverySelection"
      );
    }
  );

  const setSelectedLocation = (locationData, selector) => {
    if (locationData?.name) {
      const current_location_html = _.template(
        currentLocationTemplate,
        locationData
      );

      $(`${selector} .current-location`).html(
        current_location_html({ data: locationData })
      );
    }

    resetForm();
    $(".selection-form").addClass("selection-form--hidden");
  };

  $(document).on("click", "#selection-bopis .set-my-store", function (e) {
    e.preventDefault();
    const locationData = $(this).data("location-data");

    if (!locationData) {
      return;
    }

    localStorage.setItem(
      "locationSelection",
      JSON.stringify(locationData || {})
    );
    $(document).trigger("setStore.rbLocation");
    setSelectedLocation(locationData, "#selection-bopis");
  });

  // Show same day delivery modal, pass data to it
  $(document).on(
    "click",
    "#selection-local-delivery .set-my-store",
    function (e) {
      e.preventDefault();
      const locationData = $(this).data("location-data");
      const miniCartItems = document.querySelectorAll(".minicart-line-item");
      const deliveryLocationModal = document.querySelector(
        ".delivery-location-modal"
      );

      if (!locationData) {
        return;
      }

      if (locationData && miniCartItems?.length) {
        deliveryLocationModal.classList.add("show");
        $(document).trigger("deliveryLocationChange", locationData);
        return;
      }

      /** Format the location name */
      locationData?.name?.replace("Physical Location - ", "");
      setSelectedLocation(locationData, "#selection-local-delivery");
      localStorage.setItem("deliverySelection", JSON.stringify(locationData));
      $(document).trigger("setStore.rbLocation");
    }
  );

  // Listen to deliveryLocationChange event to set delivery location and trigger inventory check
  $(document).on("deliveryLocationChange", function (e, locationData) {
    $(document).on("click", ".delivery-location-change", async function (e) {
      e.preventDefault();

      if (!locationData) {
        return;
      }

      const deliveryLocationModal = document.querySelector(
        ".delivery-location-modal"
      );
      deliveryLocationModal.classList.remove("show");

      /** Format the location name */
      locationData?.name?.replace("Physical Location - ", "");
      setSelectedLocation(locationData, "#selection-local-delivery");
      localStorage.setItem("deliverySelection", JSON.stringify(locationData));

      MiniCart.clearCart();

      // Disable cart ATC, Trigger inventory check
      $(document).trigger("setStore.rbLocation");
    });
  });

  $(document).on("click", ".delivery-location-cancel", function (e) {
    e.preventDefault();
    const deliveryLocationModal = document.querySelector(
      ".delivery-location-modal"
    );
    if (deliveryLocationModal) {
      deliveryLocationModal.classList.remove("show");
      $(document).trigger("deliveryLocationChange", null);
    }
  });
  // change modal no = close modal

  $(document).on("click", ".change-location", function (e) {
    e.preventDefault();
    $(this).addClass("change-location--hidden");
    $(this)
      .parent()
      .siblings(".selection-form--hidden")
      .removeClass("selection-form--hidden");
    $(this).parent().siblings("#location-search-form__product").focus();
    $(this).parent().siblings(".selection-form").show();
  });

  $('input[name="properties[_shipping]"]').on("change", resetForm);
})(jQuery);
